import type { TroopKit } from "../kit/types";

/**
 * The Royal Guard troop skin (gems, common band; contract tools/art/skins/README.md §Troops). Its own soldier,
 * `art/hq/troop_soldier__royal.glb` (+ `_lod1`), built on the unit kit by tools/art/skins/troops.py
 * (art/unitkit/units_troops_v2.py + anim_troopskins.py; troops v2 2026-10-27: a navy coat under the white-gold plate,
 * real metal, the one troop body scale - the tips below were re-measured from it) at the stock soldier's scale and rig:
 * white-gold plate under gold trim, a tall white plume over a gold-combed helm, a royal-blue tabard and a long
 * royal-blue cape in two cloth parts that streams behind the march, a gold-trimmed tower shield with the crest, and a
 * halberd flying a royal-blue swallowtail pennant. Royal blue, not red: crimson is the Ashen Horde's colour
 * (art/unitkit/STYLE_GUIDE.md). Its own clips: the banner salute (`fidget`: the halberd raised high with the pennant
 * streaming, brought upright before the face, planted with a stamp), a parade march, an overhead halberd chop and a
 * spike thrust, the banner pumped in the cheer.
 * `fx` (kit/troopFx.ts): a gold glint off the halberd's head as each blow lands, and now and then a glint on it while
 * the guard stands. `fallback`: the legacy tabard tint while the model is not in the manifest.
 */
export const ROYAL: TroopKit = {
  id: "troop.royal",
  model: "troop_soldier__royal",
  fallback: { tint: 0xf2e2b0, mix: 0.6, gain: 1.05, keepAccents: false, trim: { colour: 0xffd27a, strength: 0.4 } },
  fx: {
    strike: { tip: [0.014, 0.2, -0.013], glint: { colour: 0xffd36e, count: 5, flash: 0.16 } },
    idle: { node: "weapon", at: [0.013, 0.174, -0.011], kind: "glints", colour: 0xffe08a, count: 2, every: [4, 8] },
  },
};
